import { useEffect, useState } from 'react'

import { DateTime } from 'luxon'
import { ProductItem, ProductItemInput } from 'types/graphql'

import { PromoCodeInfo } from '.'

const getPromoCodeInfo = (
  product: ProductItemInput,
  directUrl: string
): PromoCodeInfo => {
  const getStringDate = (date?: string | Date) =>
    date
      ? typeof date === 'string'
        ? date
        : DateTime.fromJSDate(date).toString()
      : null

  const getMinFromNow = (stringDate: string) =>
    parseFloat(DateTime.fromISO(stringDate).diff(DateTime.now()).toFormat('m'))

  const getRelativeDate = (date: string) => {
    const fromIso = DateTime.fromISO(date)

    return fromIso.month !== DateTime.now().month &&
      fromIso.diffNow('day').days <= 1
      ? 'tomorrow'
      : fromIso.toRelativeCalendar()
  }
  const minToDays = (min: number) => Math.round(min / 60 / 24)
  const daysToMin = (days: number) => Math.round(days * 60 * 24)

  const validFrom = getStringDate(product?.promoCodeValidFrom)
  const validTo = getStringDate(product?.promoCodeValidTo)

  const minTilPromoStarts = !validFrom ? -1000000 : getMinFromNow(validFrom)
  const minTilPromoEnds = !validTo ? 10000000 : getMinFromNow(validTo)

  // See https://github.com/moment/luxon/issues/394
  const labelEnding =
    minTilPromoEnds < daysToMin(1) && minTilPromoEnds > 0
      ? `${getRelativeDate(validTo)}` === 'today'
        ? 'today'
        : 'tomorrow'
      : `in ${minToDays(minTilPromoEnds)} days`

  const label =
    minTilPromoEnds > 0 && minTilPromoEnds <= daysToMin(30)
      ? `Promo code exp. ${labelEnding}`
      : null

  const result: PromoCodeInfo = {
    hasCode: !!product?.promoCodeCode,
    currentlyValid: minTilPromoStarts <= 0 && minTilPromoEnds > 0,
    expirationLabel: undefined,
  }

  result.expirationLabel =
    directUrl && result?.hasCode && result.currentlyValid ? label : undefined

  return result
}

export default function useProductCard(productItem: ProductItem, url?: string) {
  const [promoCodeInfo, setPromoCodeInfo] = useState<PromoCodeInfo>()
  useEffect(() => {
    setPromoCodeInfo(getPromoCodeInfo(productItem, url))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    productItem.promoCodeCode,
    productItem.promoCodeDiscount,
    productItem.promoCodeValidFrom,
    productItem.promoCodeValidTo,
    url,
  ])
  return { promoCodeInfo }
}
